import React, { useState } from 'react';
import FormBuilderBulkActionCardView from '../view/FormBuilderBulkActionCardView';

const FormBuilderBulkActionCardEngine = ({
  bulkActionData = {},
  customStatusLabels = {},
  label = '',
  statuses = [],
  updateValue = '',
  id,
  position,
  onEdit = () => {},
  onDelete = () => {},
  update = () => {}
}) => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isInDeleteSequence, setIsInDeleteSequence] = useState(false);
  const statusesDisplay = statuses
    .filter(one => one !== 'all')
    .map(status => customStatusLabels[status] || status) || [''];
  const viewProps = {
    bulkActionData,
    label,
    updateValue,
    updateValueDisplay: customStatusLabels[updateValue] || updateValue,
    statuses,
    statusesDisplay,
    id,
    plusStatusesNumber: statusesDisplay.length - 1,
    position,
    onEdit,
    onDelete,
    update,
    isDeleteDialogOpen,
    setIsDeleteDialogOpen,
    setIsInDeleteSequence,
    isInDeleteSequence
  };

  return <FormBuilderBulkActionCardView {...viewProps} />;
};

export default FormBuilderBulkActionCardEngine;
